import { useState, useCallback, useEffect } from "react";
import Video from "twilio-video";
import { getTwilioToken, updateTelePatientDetails } from "../../../../../../api/PE_API";
import Room from "./Room";

// Update log
// FB  6192   02/06/2023  DK  Video component for the tele appointments

const VideoChat = (props) => {
    const [room, setRoom] = useState(null);
    const [connecting, setConnecting] = useState(false);

    const username = props.match.params.patient;
    const roomName = props.match.params.room;

    useEffect(() => {
        async function getToken() {
            const response = await getTwilioToken(username, roomName);
            Video.connect(response, {
                name: roomName,
            })
                .then((room) => {
                    setConnecting(false);
                    setRoom(room);
                })
                .catch((err) => {
                    console.error(err);
                    setConnecting(false);
                });
        }

        getToken();
    }, []);


    const handleLogout = useCallback(() => {
        setRoom((prevRoom) => {
            if (prevRoom) {
                prevRoom.localParticipant.tracks.forEach((trackPub) => {
                    trackPub.track.stop();
                });
                prevRoom.disconnect();
                updateTelePatientDetails(0, roomName);
            }
            return null;
        });
    }, []);

    useEffect(() => {
        if (room) {
            const tidyUp = (event) => {
                if (event.persisted) {
                    return;
                }
                if (room) {
                    handleLogout();
                }
            };
            window.addEventListener("pagehide", tidyUp);
            window.addEventListener("beforeunload", tidyUp);
            return () => {
                window.removeEventListener("pagehide", tidyUp);
                window.removeEventListener("beforeunload", tidyUp);
            };
        }
    }, [room, handleLogout]);

    const scrollTo = (ref) => {
        if (ref) {
            ref.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    let render;
    if (room) {
        render = (
            <section
                ref={scrollTo}
                style={{
                    margin: "20px 20px 20px",
                }}
            >
                <Room
                    roomName={roomName}
                    identity={username}
                    room={room}
                    handleLogout={handleLogout} />
            </section>
        );
    } else {
        render = (
            <div></div>
        );
    }
    return render;
};
export default VideoChat;